import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";

const OurMission = () => {
  const { t } = useLanguage();
  const benefits = t("mission.benefits", []);

  return (
    <div className="mt-[65px] lg:mt-[80px] min-h-screen pb-20 md:pb-0 bg-white">
      <div className="mx-auto h-full sm:max-w-3xl lg:max-w-screen-2xl 2xl:max-w-screen-2xl px-5 md:px-8">
        <div className="w-full text-center pt-16 pb-6">
          <p className="text-sm md:text-base font-semibold uppercase tracking-widest text-orange mb-3">
            {t("mission.label")}
          </p>
          <h1 className="text-blue text-2xl md:text-3xl lg:text-4xl font-bold leading-snug max-w-4xl mx-auto">
            {t("mission.title")}
          </h1>
          <div className="mt-4 mx-auto w-20 h-1 rounded-full bg-gradient-to-r from-orange to-pink" />
        </div>

        <div className="max-w-4xl mx-auto mt-8">
          <p className="text-lg md:text-xl font-semibold text-orange">
            {t("mission.subtitle")}
          </p>
        </div>

        <div className="max-w-4xl mx-auto mt-8 mb-10">
          <div className="grid grid-cols-1 gap-4">
            {benefits.map((item, i) => (
              <div
                key={i}
                className="flex items-start gap-4 p-4 rounded-xl bg-white border border-blue/10 shadow-sm shadow-blue/5 transition-all duration-300 hover:shadow-md hover:border-blue/25 hover:-translate-y-0.5"
              >
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-br from-lightBlue to-blue flex items-center justify-center text-white text-sm font-bold shadow-md">
                  {i + 1}
                </span>
                <p className="text-base md:text-lg text-darkBlue/80 leading-relaxed pt-0.5">
                  {item}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurMission;
